module.exports = __webpack_public_path__ + "img/router-store-card.446560c5.svg";